import React from 'react'
import ModalFormUI from '../../../widgets/form/ModalFormUI'
import InputTextUI from '../../../widgets/form/InputTextUI'

const NachReportInternalRemarksUpdateModalUI = ({
  context,
  successMsg,
  errorList,
  setErrorList,
  updateMode,
  submitted,
  onSubmit,
  onCancelClick,
  internalRemarks,
  onInternalRemarksChange,
  internalRemarksError,
}) =>
  <ModalFormUI
    context={context}
    titleLabel='Update internal remarks'
    buttonLabel='Update'
    cancelLabel='Cancel'
    isOpen={updateMode}
    onRequestClose={onCancelClick}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onSubmit={onSubmit}
    busy={submitted}
  >
    <InputTextUI
      context={context}
      name='internalRemarks'
      label='Internal Remarks'
      value={internalRemarks || ''}
      onChange={onInternalRemarksChange}
      error={internalRemarksError}
      maxLength={500}
      autoFocus={true}
    />
  </ModalFormUI>

export default NachReportInternalRemarksUpdateModalUI
